import { render, staticRenderFns } from "./seasonprices.vue?vue&type=template&id=05fa8bfb&"
import script from "./seasonprices.vue?vue&type=script&lang=js&"
export * from "./seasonprices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05fa8bfb')) {
      api.createRecord('05fa8bfb', component.options)
    } else {
      api.reload('05fa8bfb', component.options)
    }
    module.hot.accept("./seasonprices.vue?vue&type=template&id=05fa8bfb&", function () {
      api.rerender('05fa8bfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2I50zaeURC6Je/JS/comp/seasonprices.vue"
export default component.exports